import React, { useState, useEffect, useMemo } from 'react'
import { usePermission } from 'api/hooks/use-permissions'
import Select, { components } from 'react-select'

function PermissionValueDropdown({ permissionId, params, setParams }) {
  const [selected, setSelected] = useState('')

  const { Option } = components
  const { data: permission, isSuccess } = usePermission({
    params: { id: permissionId },
    options: { enabled: !!permissionId }
  })

  const CustomOption = (props) => (
    <Option {...props}>
      <span className="me-1">{props.data.label}</span>
    </Option>
  )
  const SingleValue = ({ children, ...props }) => (
    <React.Fragment>
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </React.Fragment>
  )

  const options = useMemo(
    () =>
      isSuccess
        ? permission.permission_values.map((pv) => ({
            label: pv.value_caption
              ? `${pv.value} - ${pv.value_caption}`
              : pv.value,
            value: pv.id,
            permissionValueId: pv.id
          }))
        : [],
    [isSuccess, permission]
  )

  useEffect(() => {
    if (!isSuccess || params.permission_value_id) return
    const expansiveValues = permission.permission_values.filter((pv) => pv.is_expansive)
    if (expansiveValues.length === 1) {
      const pv = expansiveValues[0]
      const option = options.find((o) => o.permissionValueId === pv.id)
      setSelected(option)
      setParams((prev) => ({ ...prev, permission_value_id: pv.id }))
    }
  }, [isSuccess, permission, params.permission_value_id, options, setParams])

  useEffect(() => {
    if (params.permission_value_id && isSuccess) {
      const selectedOption = options.find(
        (o) => o.permissionValueId === params.permission_value_id
      )
      setSelected(selectedOption)
    } else {
      setSelected('')
    }
  }, [params.permission_value_id, isSuccess, options])

  useEffect(() => {
    setSelected('')
    setParams((prev) => ({ ...prev, permission_value_id: '' }))
    // eslint-disable-next-line
  }, [permissionId])

  return (
    <Select
      options={options}
      styles={{ zIndex: 100 }}
      value={selected}
      isClearable={true}
      placeholder="Select Value"
      onChange={(val) => {
        setSelected(val)
        setParams({ ...params, permission_value_id: val?.value || '' })
      }}
      id="permission-value-selector"
      isOptionDisabled={(option) => option.disabled}
      isDisabled={!permissionId}
      components={{ SingleValue, Option: CustomOption }}
    />
  )
}

export default PermissionValueDropdown
